import * as React from "react";
import { useForm } from "../../../../../hooks/use_form_v2";
import { Form } from "../../../../Components/Form/Form/Form";
import { AutomationType, CategoryAutomationAction, categoryAutomationOptions } from "../../../../../config/automation";
import { ISelectOption, SelectField } from "../../../../Components/Form/SelectField";
import { SubFormContainer } from "../../Components/SubFormContainer";
import { CategoryField } from "../../../../Transactions/Components/Form/Fields/CategoryField";
import { SetBudget } from "./SetBudget";
import { useGlobalStores } from "../../../../../hooks/use_global_stores";
import { AutomationsValidationErrors } from "../../../../../validators/automations";

interface ICategoryFormProps {
    value: any;
    onChange(v: IAutomationFormState): void;
    errors?: AutomationsValidationErrors;
}

export interface IAutomationFormState {
    type: AutomationType.CATEGORY;
    categoryId: number;
    action: CategoryAutomationAction;
    payload: any;
}

export const CategoryForm = ({value, onChange, errors}: ICategoryFormProps) => {
    const form = useForm<IAutomationFormState>(value || {}, {prevFormErrors: errors});
    const { register, watch, getValues } = form;

    const { budgetStore } = useGlobalStores();

    React.useEffect(() => {
        onChange(getValues());
    }, [getValues()]);

    const optionDisabledGetter = (v: ISelectOption) => {
        if (v.value === CategoryAutomationAction.SET_BUDGET) {
            return budgetStore.budgets.length === 0;
        }

        return false;
    };

    const handelSubmit = (values: IAutomationFormState) => {
        return Promise.resolve();
    };

    return (
        <SubFormContainer>
            <Form form={form} onSubmit={handelSubmit} withSubmitButton={false} component="div">
                <Form.Field type={CategoryField} {...register('categoryId')} />

                <Form.Field
                    type={SelectField}
                    {...register('action')}
                    options={categoryAutomationOptions}
                    optionDisabledGetter={optionDisabledGetter}
                />

                <Form.Field
                    type={SetBudget}
                    {...register('payload')}
                    conditional={watch('action') === CategoryAutomationAction.SET_BUDGET}
                    errors={errors}
                    noWrapper
                />
            </Form>
        </SubFormContainer>
    );
}
